<template>
  <div class="order-detail-page">
    <el-tag>订单信息</el-tag>
    <el-form ref="form" :model="header" label-width="80px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="订单号">
            <span>{{header.SalesCode}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="下单时间">
            <span>{{header.CreateDate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态">
            <span>{{header.StatusName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户">
            <span>{{header.GuestName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="总金额">
            <span>{{header.TotalPrice}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="折扣金额">
            <span>{{header.DiscountAmount}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款金额">
            <span>{{header.ReceiveAmount}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="说明">
            <span>{{header.Description}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="details" border style="width: 100%" v-loading="loading">
      <el-table-column prop="GoodsCode" label="商品编码" width="180"></el-table-column>
      <el-table-column prop="GoodsName" label="商品名称"></el-table-column>
      <el-table-column prop="UnitPrice" label="单价"></el-table-column>
      <el-table-column prop="BatchQuantity" label="整件数量" width="180"></el-table-column>
      <el-table-column prop="PieceQuantity" label="散装数量" width="180"></el-table-column>
      <el-table-column prop="PackQuantity" label="包装数量" width="180"></el-table-column>
      <el-table-column prop="Price" label="小计"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import {getOrderForm} from '../../api/order'
import {fmtTime} from '../../api/utils'

export default {
  data() {
    return {
      header: {},
      details: []
    };
  },
  created(){
    this.onLoadSalesForm();
  },
  methods:{
    onLoadSalesForm:function(){
      var that = this;
      this.loading = true
      getOrderForm(this.$route.params.orderCode).then(resp=>{
        that.loading = false
        if (resp.data.code == 100){
          resp.data.data.header.CreateDate = fmtTime(resp.data.data.header.CreateDate);
          resp.data.data.header.StatusName = this.getStatusName(resp.data.data.header.FormStatus);
          that.header = resp.data.data.header;
          that.details = resp.data.data.details;
        }else{
          that.$notify.error({title: '失败',message: "加载数据失败：" + resp.data.msg})
        }
      },err=>{
        that.loading = false
        that.$notify.error({title:'查询失败',message:err.statusText})
      });
    },
    getStatusName:function(status){
      switch(status){
        case 0: return "已保存";
        case 1: return "已提交";
        case 2: return "同步";
        case 3: return "已结算";
        case -1: return "已取消";
        default: return "其他";
      }
    },
  }
}
</script>
